import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TEMPORARY: hardcoded config to bypass .env loading issues
// TODO: revert to process.env.REACT_APP_* once connection is confirmed
const firebaseConfig = {
  apiKey:            "AIzaSyA4o9xm8vvMgC9X-aV8Z8DZ6t1dA34AOp0",
  authDomain:        "champion-arena-75406.firebaseapp.com",
  projectId:         "champion-arena-75406",
  storageBucket:     "champion-arena-75406.firebasestorage.app",
  messagingSenderId: "705669318579",
  appId:             "1:705669318579:web:a1df162a482c2bba4dadc6",
};

console.log("[Firebase] Initializing with project:", firebaseConfig.projectId);

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
console.log("[Firebase] Firestore db instance created:", !!db);
